module.exports = __webpack_public_path__ + "static/media/m1_sf_3.9ee9504f.png";